<h2 mat-dialog-title>Seleccione ubicación</h2>
<div mat-dialog-content>
  <div id="mapLocationSelector" style="width: 100%; height: 400px"></div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>